import axios from "@/repositories/client";

axios.getSaleStats = (hotel, interval) => {
  let options = {
    params: {
      hotel_id: hotel,
      since: interval.from,
      until: interval.until,
      includes: ['room_types', 'rate_plans']
    }
  };

  return axios.get(`athena/v1/statistics/sales`, options)
    .then(response => {
      return response.data;
    });
};

axios.getOccupancyStats = (hotel, interval) => {
  let options = {
    params: {
      hotel_id: hotel,
      since: interval.from,
      until: interval.until,
      includes: ['room_types']
    }
  };

  return axios.get(`athena/v1/statistics/occupancy`, options)
    .then(response => {
      return response.data;
    });
};

export default axios;
